import type { HTMLAttributes } from "react";
import { cn } from "@/lib/cn";

/**
 * Shimmer placeholder for loading states.
 * Usage: `<Skeleton className="h-4 w-24" />`
 */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "rounded-md bg-gradient-to-r from-surface via-surface-raised to-surface",
        "animate-pulse",
        className,
      )}
      aria-busy="true"
      aria-live="polite"
      {...props}
    />
  );
}
